import { render, staticRenderFns } from "./Clipboard.vue?vue&type=template&id=f947e104&scoped=true"
import script from "./Clipboard.vue?vue&type=script&lang=js"
export * from "./Clipboard.vue?vue&type=script&lang=js"
import style0 from "./Clipboard.vue?vue&type=style&index=0&id=f947e104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f947e104",
  null
  
)

export default component.exports